import { Card, LegacyStack, Page } from "@shopify/polaris";
import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";
import React, { useEffect } from "react";

import { useMigrationStatusHandler } from "./hooks/StatusHandler";
import { NewMigrationTable } from "./components/NewMigrationTable";
import { DromoContainer } from "@vendor-app/app/AdminRoute/AdminMigrationsRoute/Manual/components/DromoContainer";
import { MigrationFileUploadAccess } from "@vendor-app/app/AdminRoute/AdminMigrationsRoute/Manual/stores/MigrationFileUpload";

export const ManualMigration = () => {
  const user = useSmartrrVendorSelector(state => state.auth.user);
  const uploadActions = MigrationFileUploadAccess.useActions();

  useMigrationStatusHandler();

  useEffect(() => {
    uploadActions.setUser(user);
  }, [!user]);

  return (
    <Page title="Manual migrations">
      <LegacyStack spacing="loose" vertical>
        <Card padding="600">
          <LegacyStack spacing="loose" vertical>
            <DromoContainer />
          </LegacyStack>
        </Card>
        <NewMigrationTable />
      </LegacyStack>
    </Page>
  );
};
